import { render } from "./UserPanel.vue?vue&type=template&id=40067da8&scoped=true&ts=true"
import script from "./UserPanel.vue?vue&type=script&lang=ts"
export * from "./UserPanel.vue?vue&type=script&lang=ts"

import "./UserPanel.vue?vue&type=style&index=0&id=40067da8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40067da8"]])

export default __exports__